export const SET_DEVICES = 'SET_DEVICES'
export function setDevices(devices) {
    return {
        type: SET_DEVICES,
        devices
    }
}

export const START_LOADING = 'START_LOADING'
export function startLoading() {
    return {
        type: START_LOADING,
        isLoading: true
    }
}

export const DEVICES_REQUEST = 'DEVICES_REQUEST'
export function devicesRequest(filters) {
    return {
        type: DEVICES_REQUEST,
        filters
    }
}

export const DEVICES_REQUEST_SUCCESS = 'DEVICES_REQUEST_SUCCESS'
export function devicesRequestSuccess(devices) {
    return {
        type: DEVICES_REQUEST_SUCCESS,
        devices
    }
}

export const DEVICES_REQUEST_ERROR = 'DEVICES_REQUEST_ERROR'
export function devicesRequestError() {
    return {
        type: DEVICES_REQUEST_ERROR
    }
}

export const DEVICE_REQUEST = 'DEVICE_REQUEST'
export function deviceRequest(deviceId) {
    return {
        type: DEVICE_REQUEST,
        deviceId
    }
}

export const DEVICE_REQUEST_SUCCESS = 'DEVICE_REQUEST_SUCCESS'
export function deviceRequestSuccess(device) {
    return {
        type: DEVICE_REQUEST_SUCCESS,
        device
    }
}

export const DEVICE_REQUEST_ERROR = 'DEVICE_REQUEST_ERROR'
export function deviceRequestError() {
    return {
        type: DEVICE_REQUEST_ERROR
    }
}

export const DEVICE_REPORTS_REQUEST = 'DEVICE_REPORTS_REQUEST'
export function deviceReportsRequest(deviceId, filters) {
    return {
        type: DEVICE_REPORTS_REQUEST,
        deviceId,
        filters
    }
}

export const DEVICE_REPORTS_SUCCESS = 'DEVICE_REPORTS_SUCCESS'
export function deviceReportsSuccess(deviceReports) {
    return {
        type: DEVICE_REPORTS_SUCCESS,
        deviceReports
    }
}

export const DEVICE_REPORTS_ERROR = 'DEVICE_REPORTS_ERROR'
export function deviceReportsError() {
    return {
        type: DEVICE_REPORTS_ERROR
    }
}

export const SHARED_USERS_REQUEST = 'SHARED_USERS_REQUEST'
export function sharedUsersRequest() {
    return {
        type: SHARED_USERS_REQUEST
    }
}

export const SHARED_USERS_REQUEST_SUCCESS = 'SHARED_USERS_REQUEST_SUCCESS'
export function sharedUsersRequestSuccess(sharedUsers) {
    return {
        type: SHARED_USERS_REQUEST_SUCCESS,
        sharedUsers
    }
}

export const SHARED_USERS_REQUEST_ERROR = 'SHARED_USERS_REQUEST_ERROR'
export function sharedUsersRequestError() {
    return {
        type: SHARED_USERS_REQUEST_ERROR
    }
}

export const SHARE_DEVICES_REQUEST = 'SHARE_DEVICES_REQUEST'
export function shareDevicesRequest(devices) {
    return {
        type: SHARE_DEVICES_REQUEST,
        devices
    }
}

export const SHARE_DEVICES_SUCCESS = 'SHARE_DEVICES_SUCCESS'
export function shareDevicesSuccess() {
    return {
        type: SHARE_DEVICES_SUCCESS
    }
}

export const SHARE_DEVICES_ERROR = 'SHARE_DEVICES_ERROR'
export function shareDevicesError() {
    return {
        type: SHARE_DEVICES_ERROR
    }
}

export const RESET_DEVICE_REQUEST = 'RESET_DEVICE_REQUEST'
export function resetDeviceRequest(deviceId, filters) {
    return {
        type: RESET_DEVICE_REQUEST,
        deviceId,
        filters
    }
}

export const RESET_DEVICE_SUCCESS = 'RESET_DEVICE_SUCCESS'
export function resetDeviceSuccess() {
    return {
        type: RESET_DEVICE_SUCCESS
    }
}

export const RESET_DEVICE_ERROR = 'RESET_DEVICE_ERROR'
export function resetDeviceError() {
    return {
        type: RESET_DEVICE_ERROR
    }
}

export const REPORT_CATCH_REQUEST = 'REPORT_CATCH_REQUEST'
export function reportCatchRequest(
    deviceId,
    catchDescription,
    created_at,
    filters
) {
    return {
        type: REPORT_CATCH_REQUEST,
        deviceId,
        catchDescription,
        created_at,
        filters
    }
}

export const REPORT_CATCH_SUCCESS = 'REPORT_CATCH_SUCCESS'
export function reportCatchSuccess() {
    return {
        type: REPORT_CATCH_SUCCESS
    }
}

export const REPORT_CATCH_ERROR = 'REPORT_CATCH_ERROR'
export function reportCatchError() {
    return {
        type: REPORT_CATCH_ERROR
    }
}

export const SET_OFFLINE_REQUEST = 'SET_OFFLINE_REQUEST'
export function setOfflineRequest(deviceId, filters) {
    return {
        type: SET_OFFLINE_REQUEST,
        deviceId,
        filters
    }
}

export const SET_OFFLINE_SUCCESS = 'SET_OFFLINE_SUCCESS'
export function setOfflineSuccess() {
    return {
        type: SET_OFFLINE_SUCCESS
    }
}

export const SET_OFFLINE_ERROR = 'SET_OFFLINE_ERROR'
export function setOfflineError() {
    return {
        type: SET_OFFLINE_ERROR
    }
}

export const BATTERY_RESET_REQUEST = 'BATTERY_RESET_REQUEST'
export function batteryResetRequest(deviceId) {
    return {
        type: BATTERY_RESET_REQUEST,
        deviceId
    }
}

export const BATTERY_RESET_SUCCESS = 'BATTERY_RESET_SUCCESS'
export function batteryResetSuccess() {
    return {
        type: BATTERY_RESET_SUCCESS
    }
}

export const BATTERY_RESET_ERROR = 'BATTERY_RESET_ERROR'
export function batteryResetError() {
    return {
        type: BATTERY_RESET_ERROR
    }
}

export const SET_STATUS_ACTIVE_TOM_REQUEST = 'SET_STATUS_ACTIVE_TOM_REQUEST'
export function setStatusActiveTOMRequest(deviceId) {
    return {
        type: SET_STATUS_ACTIVE_TOM_REQUEST,
        deviceId
    }
}

export const SET_STATUS_ACTIVE_TOM_SUCCESS = 'SET_STATUS_ACTIVE_TOM_SUCCESS'
export function setStatusActiveTOMSuccess() {
    return {
        type: SET_STATUS_ACTIVE_TOM_SUCCESS
    }
}

export const UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST'
export function updateDeviceRequest(deviceId, body) {
    return {
        type: UPDATE_DEVICE_REQUEST,
        deviceId,
        body
    }
}

export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS'
export function updateDeviceSuccess() {
    return {
        type: UPDATE_DEVICE_SUCCESS
    }
}

export const UPDATE_DEVICE_ERROR = 'UPDATE_DEVICE_ERROR'
export function updateDeviceError() {
    return {
        type: UPDATE_DEVICE_ERROR
    }
}

export const FETCH_MORE_DEVICES = 'FETCH_MORE_DEVICES'
export function fetchMoreDevices(filters) {
    return {
        type: FETCH_MORE_DEVICES,
        filters
    }
}

export const DEVICES_REQUEST_MORE_SUCCESS = 'DEVICES_REQUEST_MORE_SUCCESS'
export function devicesRequestMoreSuccess(devices) {
    return {
        type: DEVICES_REQUEST_MORE_SUCCESS,
        devices
    }
}

export const DEVICES_REQUEST_MORE_ERROR = 'DEVICES_REQUEST_MORE_ERROR'
export function devicesRequestMoreError() {
    return {
        type: DEVICES_REQUEST_MORE_ERROR
    }
}

export const POST_NEW_DEVICE_IMAGES = 'POST_NEW_DEVICE_IMAGES'
export function postDeviceImages(deviceParams) {
    return {
        type: POST_NEW_DEVICE_IMAGES,
        deviceParams
    }
}

export const GET_IMAGES_BY_DEVICE_ID = 'GET_IMAGES_BY_DEVICE_ID'
export function getImagesByDeviceId(deviceId) {
    return {
        type: GET_IMAGES_BY_DEVICE_ID,
        deviceId
    }
}

export const SET_IMAGES_FOR_DEVICES = 'SET_IMAGES_FOR_DEVICES'
export function setImagesForDevices(images) {
    return {
        type: SET_IMAGES_FOR_DEVICES,
        images
    }
}

export const DELETE_DEVICE_IMAGES = 'DELETE_DEVICE_IMAGES'
export function deleteDeviceImages(deviceParams) {
    return {
        type: DELETE_DEVICE_IMAGES,
        deviceParams
    }
}
export const SET_DEVICE_IMAGES_LOADER = 'SET_DEVICE_IMAGES_LOADER'
export function setDeviceImagesLoader(loading) {
    return {
        type: SET_DEVICE_IMAGES_LOADER,
        loading
    }
}

export const SET_MAINTENANCE_MODE = 'SET_MAINTENANCE_MODE'
export function setMaintenanceMode(
    deviceId,
    inMaintenanceMode,
    durationMinutes
) {
    return {
        type: SET_MAINTENANCE_MODE,
        deviceId,
        inMaintenanceMode,
        durationMinutes
    }
}
